class MMProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            if (typeof window.globalEmit === 'function') {
                window.globalEmit('product-recommendations-loading');
            }

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    
                    // On cible notre nouvelle balise
                    const recommendations = html.querySelector('mm-product-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        
                        // Wishlist
                        if (window.wishlistManager) window.wishlistManager.initButtons();
                        if (typeof window.initAddToCartForms === 'function') window.initAddToCartForms();
                        
                        // Lancement de Splide
                        const splideElement = this.querySelector('.splide');
                        if (splideElement) {
                            // Sécurité pour trouver Splide (selon comment il est importé dans ton thème)
                            const SplideClass = window.Splide || (typeof Splide !== 'undefined' ? Splide : null);
                            
                            if (SplideClass) {
                                const splideOptions = JSON.parse(splideElement.dataset.splide || '{}');
                                new SplideClass(splideElement, splideOptions).mount();
                            } else {
                                console.warn("Attention : Splide n'est pas disponible pour initialiser le slider.");
                            }
                        }
                        
                        document.dispatchEvent(new CustomEvent('product-recommendations-loaded'));
                    } else {
                        this.style.display = 'none';
                        if (typeof window.globalEmit === 'function') window.globalEmit('product-recommendations-empty');
                    }
                })
                .catch((error) => console.error('Failed to load product recommendations', error));
        };

        new IntersectionObserver(handleIntersection.bind(this), { 
            rootMargin: '0px 0px 400px 0px' 
        }).observe(this);
    }
}

// On enregistre notre composant unique !
if (!customElements.get('mm-product-recommendations')) {
    customElements.define('mm-product-recommendations', MMProductRecommendations);
}